import React, {
} from 'react';

import classes from './ResourcesCell.module.scss';
import avatar from '../../../../../components/Icons/avatar.png';

const AttentionIcon = ({color, ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      fill="none"
      {...props}
    >
      <path
        fill="#FD4646"
        d="M15 28c7.18 0 13-5.82 13-13S22.18 2 15 2 2 7.82 2 15s5.82 13 13 13Z"
        opacity={0.1}
      />
      <path
        fill="#FD4646"
        d="M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z"
        opacity={0.1}
      />
      <path
        fill="#FD4646"
        d="M14.132 7.52a1 1 0 0 1 1.736 0l6.277 10.98a1.001 1.001 0 0 1-.868 1.5H8.723a1 1 0 0 1-.868-1.5l6.277-10.98Z"
      />
      <path stroke="#fff" strokeLinecap="round" d="M15 12.37v2.664" />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={1.2}
        d="M15 16.707v.009"
      />
    </svg>
  )
}

const AttentionActiveIcon = ({color, ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      fill="none"
      {...props}
    >
      <path
        fill="#FD4646"
        d="M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z"
      />
      <path
        fill="#fff"
        d="M14.132 7.52a1 1 0 0 1 1.736 0l6.277 10.98a1.001 1.001 0 0 1-.868 1.5H8.723a1 1 0 0 1-.868-1.5l6.277-10.98Z"
      />
      <path stroke="#FD4646" strokeLinecap="round" d="M15 12.37v2.664" />
      <path
        stroke="#FD4646"
        strokeLinecap="round"
        strokeWidth={1.2}
        d="M15 16.707v.009"
      />
    </svg>
  )
}

const ResourceCell = ({
  title,
  skill,
  place,
  photo,
  height = (41*3)+7,
  aggregatedAiResults,
  isOvertime,
  overtimeDays,
  index,
}) => {

  return (
    <>
      <div className={classes.resourcesCell} style={{"height" : height+"px", paddingTop: 12}}>
        <div className={classes.resourcesCell__content} style={{flexDirection: 'column', justifyContent: 'center', alifnItems: 'center', padding: 0}}>
          {
            isOvertime
              ? <div className={classes.resourceAttentionContainer} data-tooltip-id="title" data-tooltip-html={overtimeDays.join(', ')}>
                  <div className={classes.resourceAttention}>
                    <AttentionIcon />
                    <AttentionActiveIcon />
                  </div>
                </div>
              : null
          }
          <div style={{flexDirection: 'row', display: 'flex', alignItems: 'center'}}>
            <div className={classes.resourcesCell__content__avatar}>
              <img src={photo || avatar} alt={title} />
            </div>
            <div className={classes.resourcesCell__content__name}>
              { title ? <div>{title}</div> : null }
              { skill ? <div>{skill}</div> : null }
              { place ? <div>{place}</div> : null }
            </div>
          </div>
          {
            aggregatedAiResults
              ? <div style={{marginTop: 16}}>
                  <div style={{fontSize: 11}}>Total hours target: <b>{aggregatedAiResults.month_cap_minutes}</b></div>
                  <div style={{fontSize: 11}}>Total hours original: <b>{aggregatedAiResults.original_month_minutes}</b></div>
                  <div style={{fontSize: 11}}>Total hours AI generated: <b>{aggregatedAiResults.ai_month_minutes}</b></div>
                </div>
              : null
          }
        </div>
      </div>
    </>
  );
};

export default ResourceCell;
